// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2B2KU","location":"Header_location__1_UMr"};